import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
    MenuItem,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import { generateAndExecuteMutation, graphqlQuery } from "../../../../data/Axios/DynamicService";
import { caseManagementUrl } from "../../../../config";
import Header from "../../../../components/Header";
import CaseCategory from ".";
import { all } from "axios";
import { caseCategory } from "../../../../data/Axios/queries";

const base_url = caseManagementUrl.uri;

const CaseSubCategoryForm = (props) => {
  const { onAction } = props;
  const initialValues = {
    categoryId: props.data?.categoryId || "",
    subcategoryName: props.data?.subcategoryName || "",
    description: props.data?.description || "",
  };

  const validationSchema = yup.object().shape({
    subcategoryName: yup.string().required("Subcategory name is required"),
    description: yup.string().required("Description is required"),
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


    const [categoryData, setCategoryData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      async function fetchAllData() {
        try {
          const categoriessDataResponse = await graphqlQuery(caseCategory, base_url);
          if (categoriessDataResponse) {
            setCategoryData(categoriessDataResponse);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchAllData();
    }, []);

     const categoryOptions = categoryData.map((category) => ({
    value: category.id,
    label: category.categoryName,
  }));
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { categoryId, subcategoryName, description } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id, // must not be null
            categoryId: values.categoryId,
            subcategoryName: values.subcategoryName,
            description: values.description,
          }
        : {
            categoryId: values.categoryId,
            subcategoryName: values.subcategoryName,
            description: values.description,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCaseSubcategory" : "createCaseSubcategory",
        mutationData,
        "newCaseSubcategory",
        base_url
      );

      if (response && Object.values(response)[0] != null) {
        props.onClose?.();
        if (onAction) {
          onAction();
        } else {
          props.refetchData?.();
        }

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Case subcategory ${props.isEditing ? "updated" : "created"} successfully.`,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Server did not return expected data. Please check API response.",
        });
      }
    } catch (error) {
      console.error("Case subcategory creation/update error:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text:
          "An error occurred while processing your request. Please try again later.",
      });
    }
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Case Subcategory" : "Create Case Subcategory"}
        subtitle={props.isEditing ? "Edit an existing case subcategory" : "Create a new case subcategory"}
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Subcategory Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.subcategoryName}
                name="subcategoryName"
                error={touched.subcategoryName && !!errors.subcategoryName}
                helperText={touched.subcategoryName && errors.subcategoryName}
                sx={{ gridColumn: "span 4" }}
              />
                <TextField 
                select
                fullWidth
                variant="filled"
                label="Category"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.categoryId}
                name="categoryId"
                error={touched.categoryId && !!errors.categoryId}
                helperText={touched.categoryId && errors.categoryId}
                sx={{ gridColumn: "span 4" }}
              >
                {categoryOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              {/* Description */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Description"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.description}
                name="description"
                error={touched.description && !!errors.description}
                helperText={touched.description && errors.description}  
                sx={{ gridColumn: "span 4" }}
              />
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CaseSubCategoryForm;